var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannedForTodayKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planned for today"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250556",
    d: "M35.6384 24.1744H12.0907L7.05273 7.04529H42.758C43.491 7.04529 43.9749 7.80784 43.6628 8.47109L36.5432 23.6002C36.3783 23.9507 36.0258 24.1744 35.6384 24.1744Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250557",
    d: "M10.6807 8.05317L17.7338 1L24.787 8.05317",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250558",
    d: "M25.7949 5.03038L26.8025 1L36.8785 3.01519L35.8709 8.05317",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250555",
    d: "M0 5.03064H4.60405C5.46491 5.03064 6.22919 5.5815 6.50142 6.39818L13.6505 27.8454C13.9227 28.6621 14.687 29.2129 15.5479 29.2129H37.281",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 675",
    d: "M23.6824 36.2656C23.6824 38.7719 21.6507 40.8036 19.1444 40.8036C16.6382 40.8036 14.6064 38.7719 14.6064 36.2656C14.6064 33.7594 16.6382 31.7277 19.1444 31.7277C21.6507 31.7277 23.6824 33.7594 23.6824 36.2656Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 676",
    cx: 33.2499,
    cy: 36.2656,
    r: 4.53798,
    stroke: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedForTodayKpi);
export default __webpack_public_path__ + "static/media/Planned_for_today_KPI.05f5294abf441555aa3c0d3f8aa9adc3.svg";
export { ForwardRef as ReactComponent };